import React, { useState, useCallback } from "react";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import "../../../../../Utils/Css/Menu.css";

export default function Menu({
  trade_search,
  handlewSort,
  userType
}) {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  const handleSort = useCallback(
    (key) => {
      let direction = "asc";
      if (sortConfig.key === key && sortConfig.direction === "asc") {
        direction = "desc";
      }

      setSortConfig({ key, direction });

      if (!Array.isArray(trade_search)) return;

      const sortedData = [...trade_search].sort((a, b) => {
        let aVal = a[key];
        let bVal = b[key];

        if (aVal == null) aVal = "";
        if (bVal == null) bVal = "";

        // ✅ Profit/Loss sort numeric descending by default
        if (key === "profit_loss") {
          const numA = parseFloat(aVal) || 0;
          const numB = parseFloat(bVal) || 0;
          return direction === "asc" ? numA - numB : numB - numA;
        }

        // ✅ Date sorting
        if (key.toLowerCase().includes("date")) {
          const dateA = new Date(aVal).getTime();
          const dateB = new Date(bVal).getTime();
          return direction === "asc" ? dateA - dateB : dateB - dateA;
        }

        // ✅ Numeric sorting
        const numA = parseFloat(aVal);
        const numB = parseFloat(bVal);
        if (!isNaN(numA) && !isNaN(numB)) {
          return direction === "asc" ? numA - numB : numB - numA;
        }

        // ✅ String sorting fallback
        return direction === "asc"
          ? String(aVal).localeCompare(String(bVal))
          : String(bVal).localeCompare(String(aVal));
      });

      handlewSort?.(sortedData);
    },
    [sortConfig, trade_search, handlewSort]
  );

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort className="sortIcon" />;
    return sortConfig.direction === "asc" ? (
      <FaSortUp className="sortIcon" />
    ) : (
      <FaSortDown className="sortIcon" />
    );
  };

  const columns = [
    { key: "script_type", label: "EXCH" },
    ...(userType === 1 ? [{ key: "super_username", label: "SUPER" }] : []),
    ...(userType === 1 || userType === 2
      ? [{ key: "master_username", label: "MASTER" }]
      : []),
    ...(userType === 1 ||
    userType === 2 ||
    userType === 3 ||
    userType === 5 ||
    userType === 6
      ? [{ key: "username", label: "USER" }]
      : []),
    { key: "symbol", label: "SYMBOL", className: "menuSymbol" },
    { key: "expiry_date", label: "EXPIRY", className: "menuExpiry" },
    { key: "qty", label: "NET QTY", className: "menuBuyPrice" },
    { key: "standing_rate", label: "OPEN", className: "menuBuyQty" },
    { key: "rate", label: "RATE", className: "menuBuyQty" },
    { key: "buy_sell", label: "B/S", className: "menuSellQty" },
    { key: "new_deposit", label: "BALANCE", className: "menuSellQty small" },
    { key: "amount", label: "VOLUME", className: "menuSellQty small" },
    { key: "type", label: "TYPE", className: "menuSymbol small" },
    { key: "brokerage_user_amt", label: "COMM", className: "menuSellQty" },
    { key: "profit_loss", label: "P/L", className: "menuOpen" },
    { key: "other", label: "OTHER", className: "menuLtt" },
    { key: "date_created", label: "DATE", className: "menuLtt" },
    { key: "trade_duration_minutes", label: "TIME", className: "menuLtt" },
  ];

  return (
    <div className="menuContainer primary white">
      {columns.map(({ key, label, className = "menuExchange" }) => (
        <div
          key={key}
          className={`${className} ${userType === 1 || userType === 2 ? "small" : null}`}
          onClick={() => handleSort(key)}
          style={{ cursor: "pointer" }}
        >
          {label} {renderSortIcon(key)}
        </div>
      ))}
    </div>
  );
}
